<template>
  <div>
    <b-container fluid>
      <b-breadcrumb class="mt-3 mb-3" :items="breadcrumb_items" />

      <b-card class="mb-1">
        <b-row>
          <b-col cols="1" class="pr-1">
            <strong>To Client:</strong>
          </b-col>
          <b-col cols="2" class="pl-0 pr-1">
            <b-form-select
              size="sm"
              v-model="product_obj.to_client_id"
              :options="client_options"
              @change="getChannelByClient"
            />
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col cols="1" class="pr-1">
            <strong>To Channel:</strong>
          </b-col>
          <b-col cols="2" class="pl-0 pr-1">
            <b-form-select
              size="sm"
              v-model="product_obj.channel"
              :options="channel_options"
            />
          </b-col>
        </b-row>
        <hr>
        <b-form-group
          v-for="(canEditField, canEditField_i) in canEditFields"
          :key="canEditField.key"
          :id="'grp_txt_' + canEditField.key"
          :label="canEditField.label + ':'"
          :label-for="'txt_' + canEditField.key"
          label-size="sm"
        >
          <b-form-input
            :id="'txt_' + canEditField.key"
            type="text"
            required
            placeholder
            v-model="product_obj[canEditField.key]"
          ></b-form-input>
        </b-form-group>

        <!-- <b-button class="float-right" type="submit" variant="primary" @click="submitForm()">Submit</b-button> -->
      </b-card>

      <b-button
        class="mt-3 float-right"
        type="submit"
        variant="primary"
        @click="submitForm()"
        >Submit</b-button
      >
    </b-container>
  </div>
</template>

<script>
import moment from "moment";
import VueBarcode from "vue-barcode";
import global_function from "../mixins/global_function";
import apiService from "../services/ApiService";

export default {
  name: "ProductMasterClone",
  inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT"],
  mixins: [apiService, global_function],
  components: {
    barcode: VueBarcode,
  },
  data() {
    return {
      order_master_products: [],
      canEditFields: [
        {
          key: "primary_category",
          label: "primary_category",
        },
        {
          key: "product_sku",
          label: "product_sku",
        },
        {
          key: "channel_sku",
          label: "channel_sku",
        },
        {
          key: "other_sku",
          label: "other_sku",
        },
        {
          key: "lot_1",
          label: "lot_1",
        },
        {
          key: "lot_2",
          label: "lot_2",
        },
        {
          key: "vendor",
          label: "vendor",
        },
        {
          key: "brand",
          label: "brand",
        },
        {
          key: "product_description_en",
          label: "product_description_en",
        },
        {
          key: "height_cm",
          label: "height_cm",
        },
        {
          key: "width_cm",
          label: "width_cm",
        },
        {
          key: "depth_cm",
          label: "depth_cm",
        },
        {
          key: "units_ctn",
          label: "units_ctn",
        },
        {
          key: "actual_weight_kg",
          label: "actual_weight_kg",
        },
        {
          key: "shipping_weight_kg",
          label: "shipping_weight_kg",
        },
        {
          key: "expiration_date",
          label: "expiration_date",
        },
        {
          key: "default_picking_location",
          label: "default_picking_location",
        },
      ],
      breadcrumb_items: [
        {
          text: "products",
          to: { name: "products" },
        },
        {
          text: "Clone",
          active: true,
        },
      ],
      product: {},
      history_items: [],
      history_fields: [
        {
          key: "updated_at",
          label: "Updated at",
        },
        {
          key: "status",
          label: "Status",
        },
        {
          key: "pod_image",
          label: "POD",
        },
        {
          key: "updated_by",
          label: "Updated by",
        },
      ],
      loader: false,
      items: [],
      product_obj: {},
      currentPage: 1,
      table_offset: 0,
      total_rows: 0,
      manual_return_order_id: "",
      updating_item: false,
      search_criteria: {
        keyword: "",
        status_selected: null,
      },
      status_options: [
        {
          value: null,
          text: "All Status",
        },
        {
          value: "Pending",
          text: "Pending",
        },
        {
          value: "In-Transit",
          text: "In-Transit",
        },
        {
          value: "Returning to GOLS Warehouse",
          text: "Returning to GOLS Warehouse",
        },
        {
          value: "Successful Delivery",
          text: "Successful Delivery",
        },
        {
          value: "Returned to Warehouse",
          text: "Returned to Warehouse",
        },
      ],
      reschedule_type_selected: "before",
      reschedule_type_options: [
        {
          value: "before",
          text: "before",
        },
        {
          value: "on",
          text: "on",
        },
        {
          value: "after",
          text: "after",
        },
      ],
      reschedule_date: moment().format("YYYY-MM-DD"),
      showAlert_success: false,
      alert_success_message: "",
      user_id: false,
      client_options: [],
      channel_options: []
    };
  },
  async created() {
    let clients_response = await this.getClients(this.$store.state.user_obj);

    // hardcode for some
    let valid_client = [
      "Asia_Miles",
      "AsiaMiles_O2O",
      "TZP",
      "HKJC",
      "GolsPlatform",
      // "SIA",
      "BIZ",
      "CLP",
      "dcs",
      "LITOMON",
      "CityU Vet",
      "Travelpop",
      "LOJEL",
      "LOJEL_Store",
      // "Bliss & Bless",
      "ONB",
      "POR",
      "LNA",
      "Evoucher",
      "GOLSSTOCK",
      "LDN",
      "NKL",
      "PICO",
      "BBW"
    ];
    for (let i in clients_response.clients) {
      if ( valid_client.indexOf(clients_response.clients[i].client_name) != -1) {
        this.client_options.push({
          value: clients_response.clients[i].id,
          text: clients_response.clients[i].full_name,
        });
      }
    }

    await this.getProduct();
    this.initialized = true;
  },
  mounted() {
    this.loader = this.$loading.show({
      isFullPage: true,
      canCancel: false,
    });
  },
  methods: {
    
    async getChannelByClient(){
      this.channel_options = [];
      let channels_response = await this.getChannelsByClient(this.product_obj.to_client_id);
      for (let i in channels_response.channels) {
        this.channel_options.push({
          value: channels_response.channels[i].name,
          text: channels_response.channels[i].name,
        });
      }
    },

    displayDate(d) {
      if (d) {
        return moment(d).format("YYYY-MM-DD");
      } else {
        return "/";
      }
    },

    async getProduct() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "product_master_get.php",
        data: {
          product_id: this.$route.params.id,
          client_id: this.$store.state.user_obj.client_id,
        },
      });

      this.product_obj = response.data.products[0];

      this.loader.hide();
    },

    showModal_reschedule_product(item) {
      this.updating_item = item;
      this.reschedule_type_selected = "before";
      this.reschedule_date = moment().format("YYYY-MM-DD");
      this.$refs.modal_reschedule_product.show();
    },

    hideModal_reschedule_product() {
      this.$refs.modal_reschedule_product.hide();
    },

    submitForm() {
      let is_valid = true;
      let error_msg = false;

      if (this.product_obj.to_client_id == null) {
        is_valid = false;
        error_msg = "Please select client to transfer";
      }

      if (!is_valid) {
        this.$eventHub.$emit("show_modal_message", {
          message_content: error_msg,
        });
        return;
      }
      this.updateProduct(this.product_obj);
    },

    async updateProduct(product_obj) {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "product_master_clone.php",
        data: {
          product_obj: this.product_obj,
          user_id: this.$store.state.user_obj.user_id,
          client_id: this.$store.state.user_obj.client_id,
        },
      });

      if (response.data.status == "success") {
        this.$eventHub.$emit("show_modal_message", {
          message_content: `Product Clone Successfully.`,
        });
        this.getProduct();
      } else {
      }
    },
  },
};
</script>

<style>
th,
td {
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/ProductMasterClone.vue